<mat-sidenav-container>
    @if (showMenu) {
    <mat-sidenav
        class="menu"
        [class.menu-side]="isDesktop"
        [mode]="isDesktop ? 'side' : 'over'"
        [opened]="isDesktop ? true : menuOpened"
        [disableClose]="isDesktop"
        (openedChange)="onSidenavOpenedChange($event)"
    >
        <div #menuContainer class="menuContainer">
            <mat-toolbar color="primary">
                @if (!isDesktop) {
                <button mat-icon-button (click)="onSideBackClick()" aria-label="Fechar menu">
                    <mat-icon>arrow_back</mat-icon>
                </button>
                }
                <div class="user">
                    <h4 class="name">{{ (user | async)?.name }}</h4>
                    <small class="identifier">{{ (user | async)?.identifier }}</small>
                </div>
            </mat-toolbar>
            <ng-content select="[menu]"></ng-content>
        </div>
    </mat-sidenav>
    }
    <mat-sidenav-content>
        <section class="bg" [class.fillPrimary]="fillPrimary" (swiperight)="onSwipeOpenMenu()">
            @if (showActionBar) {
            <mat-toolbar id="actionbar" color="primary">
                @if ((showSearch ? (isSearchOpened$ | async) && showMenu : showMenu) && !isDesktop) {
                <button mat-icon-button (click)="toggleMenu()" aria-label="Abrir menu">
                    <mat-icon>menu</mat-icon>
                </button>
                } @if ( !showMenu && showLogout && ((showSearch && (isSearchOpened$ | async)) ||
                !showSearch) ) {
                <button mat-icon-button (click)="onLogoutClick()" aria-label="Sair">
                    <mat-icon>logout</mat-icon>
                </button>
                } @if ( !showMenu && showBack && ((showSearch && (isSearchOpened$ | async)) ||
                !showSearch) ) {
                <button mat-icon-button class="back-btn" (click)="onGoBackClick($event)" aria-label="Voltar">
                    <mat-icon>west</mat-icon>
                </button>
                } @if (!showSearch || (showSearch && isSearchOpened$ | async)) {
                <h1 class="pageTitle">
                    @if (pageTitle) {
                    {{ pageTitle }}
                    } @else {
                    Home+Leite
                    }
                </h1>
                }
                <ng-content select="[pageTitle]"></ng-content>
                @if (showSearch) {
                <app-search-box
                    backIcon="arrow_back"
                    [placeholder]="searchPlaceholder"
                    [defaultOpenOnDesktop]="true"
                    (searchDebounce)="onSearchChange($event)"
                    (clear)="onSearchClear()"
                >
                </app-search-box>
                } @if (!showSearch) {
                <div class="spacer"></div>
                }
                <ng-content select="[actions]"></ng-content>
            </mat-toolbar>
            }
            <div class="body"><ng-content></ng-content></div>
        </section>
    </mat-sidenav-content>
</mat-sidenav-container>
